import styled from 'styled-components';
import { THEME_PRIMARY, THEME_WARNING, themeColor } from '../../../styles/basics/colors';
import MaterialIcon from '../../../shared/common/MaterialIcon';

export const StAnalyticsModal = styled.div<{ height: number }>`
    max-height: ${props => props.height}px;
    overflow-y: scroll;
    padding: 0.5% 0.5% 0.5% 0;
`;
export const StAnalyticsContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 80%;
`;
export const StAnalyticsHeader = styled.h2`
    font-size: 22px;
    font-weight: bold;
`;
export const StDescriptionContainer = styled.div`
    font-size: 1.4em;
    display: flex;
    flex-direction: row;
`;
export const StCopiesContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .download-button {
        width: 180px;
    }
`;
export const StWarningValue = styled.strong`
    color: ${themeColor(THEME_WARNING)};
`;

StWarningValue.displayName = 'AnalyticsModal__StWarningValue';

export const StHSpacer = styled.div<{ factor?: number }>`
    width: ${props => (props.factor || 1) * 20}px;
`;
export const StVSpacer = styled.div<{ factor?: number }>`
    height: ${props => (props.factor || 1) * 20}px;
`;

export const StDiagramHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const StDiagramTitle = styled.span`
    font-size: 16px;
`;

StDiagramTitle.displayName = 'AnalyticsModal__StDiagramTitle';

export const StBoldGray = styled.span`
    font-weight: bold;
    color: darkgray;
`;

StBoldGray.displayName = 'AnalyticsModal__StBoldGray';

export const StDiagramLegendContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;
export const StDiagramLegendBlue = styled.span`
    display: inline-block;
    width: 25px;
    height: 10px;
    background-color: #326bfa;
    margin-right: 5px;
`;
export const StDiagramLegendGrey = styled.span`
    display: inline-block;
    width: 25px;
    height: 10px;
    background-color: #cacaca;
    margin-right: 5px;
`;
export const StDiagramLegendDescription = styled.div`
    display: flex;
    flex-direction: row;
    height: 20px;
    align-items: center;
    font-size: 12px;
`;

export const StVisitsLink = styled.a`
    color: ${themeColor(THEME_PRIMARY)};
`;

StVisitsLink.displayName = 'AnalyticsModal__StVisitsLink';

export const StCenteredMaterialIcon = styled(MaterialIcon)`
    display: inline-flex;
    align-content: center;
    vertical-align: middle !important;
    margin-left: 5px;
`;
export const StCenteredLinkText = styled.span`
    display: inline-flex;
    align-content: center;
    vertical-align: middle !important;
    margin-left: 5px;
`;

export const StVisitsTable = styled.table`
    td,
    th {
        padding: 10px 0;
        font-size: 14px;
        vertical-align: middle;
        text-align: left;
    }

    th {
        font-weight: bold;
    }
`;
